export function baseUrl(url: string = ''): string {
  return `${import.meta.env.BASE_URL}/${url.replace(/^\/|\/$/g, '')}`.replace(/\/\//g, '/')
}
